import { render, staticRenderFns } from "./TelephonyGuide.vue?vue&type=template&id=6a38b39d&scoped=true&"
import script from "./TelephonyGuide.vue?vue&type=script&lang=js&"
export * from "./TelephonyGuide.vue?vue&type=script&lang=js&"
import style0 from "./TelephonyGuide.vue?vue&type=style&index=0&id=6a38b39d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38b39d",
  null
  
)

export default component.exports